<template>
  <div class="page-wrapper" style="padding-top: 0">


    <div class="content" v-if="projectData">
      <div>项目地址：{{projectData.proAddr}}</div>
      <div>经度：{{projectData.lng}}</div>
      <div>纬度：{{projectData.lat}}</div>
      <div>VR标题：{{projectData.panoramicTitle}}</div>
      <div>VR描述：{{projectData.panoramicDesc}}</div>
      <div class="vr_span">VR链接：<a :href="projectData.panoramicUrl" target="_blank">{{projectData.panoramicUrl}}</a></div>
      <div>项目简介：<p v-html="projectData.briefInfo"></p></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ProjectBaseInfo",
    props: {
      projectData: {
        type: Object,
        default: null
      }
    },
    watch: {
    },

    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .content{
    width: 90%;
  }
  .content div{
    width: 33%;
    display: inline-block;
    margin-bottom: 32px;
    vertical-align: top;


  }
  .vr_span{
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap !important;
  }


</style>
